<template>
  <section class="app-main" :class="{ 'hide-padding': $route.meta.hidePadding, 'hide-nav-bar': $route.meta.noNavBar, 'hide-bpm-nav': hideBpmNav }">
    <div class="container" :class="{'scrm-container': $isInFrame}">
      <!-- <transition name="fade-transform" mode="out-in"> -->
      <router-view />
      <!-- </transition> -->
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  data() {
    return {
      hideBpmNav: sessionStorage.getItem('hideBpmNav')
    }
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  /* 48= navbar  60= headerbar   */
  height: calc(100vh - 108px);
  // min-width: 1200px;
  width: 100%;
  position: relative;
  overflow-y: hidden;
  padding: 20px;
  background-color: #f6f8fc;
  overflow-x: auto;
  &.hide-padding {
    padding: 0px;
  }
  &.hide-nav-bar {
    height: calc(100vh - 60px);
  }
  &.hide-bpm-nav {
    height: 100vh;
  }
  .container {
    min-width: 1200px;
    height: 100%;
    &.scrm-container {
      min-width: 820px;
    }
  }
}

</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
